module.exports = __webpack_public_path__ + "assets/img/password_m.b7171713.svg";